import { SelectOptions } from "@at/design-system-elements";

export const ANNUAL_MILEAGE_SELECT_OPTIONS: SelectOptions[] = [
  {
    value: 4000,
    displayValue: "4,000 miles",
  },
  {
    value: 6000,
    displayValue: "6,000 miles",
  },
  {
    value: 8000,
    displayValue: "8,000 miles",
  },
  {
    value: 10_000,
    displayValue: "10,000 miles",
  },
  {
    value: 12_000,
    displayValue: "12,000 miles",
  },
  {
    value: 14_000,
    displayValue: "14,000 miles",
  },
  {
    value: 16_000,
    displayValue: "16,000 miles",
  },
  {
    value: 18_000,
    displayValue: "18,000 miles",
  },
  {
    value: 20_000,
    displayValue: "20,000 miles",
  },
  {
    value: 25_000,
    displayValue: "25,000 miles",
  },
  {
    value: 30_000,
    displayValue: "30,000 miles",
  },
];
